import instance from '../_http'

export default {
  /**
   * 添加
   * @param {*} website
   * @returns
   */
  add: (website) => {
    return instance.post('/api/travel/car', website)
  },
  /**
   *  删除
   */
  remove: (id) => {
    return instance.delete(`/api/travel/car/${id}`)
  },
  /**
   * 更新
   * @param {*} website
   * @returns
   */
  update: (website) => {
    return instance.put('/api/travel/car', website)
  },
  /**
   * 查询
   * @param {*} query
   * @returns
   */
  query: (query, page) => {
    return instance.get('/api/travel/car', { params: { ...query, page: page.page, size: page.size, sort: page.sort } })
  },
  /**
   * 详情
   * @param {*} id
   * @returns
   */
  detail: (id) => {
    return instance.get(`/api/travel/car/${id}`)
  },
  /**
   * 修改默认站点
   * @param {*} id
   * @param {*} value
   * @returns
   */
  changeDefaultFlag: (id,value)=>{
    return instance.put(`/api/travel/car/${id}/defaultFlag/${value}`);
  }
}
